import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.analysis.widget.scalability');
import { OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Chart, ChartConfiguration } from 'chart.js';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-analysis-widget-scalability',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.analysis.widget.scalability/view.scss */
/* src/app/portal.analysis.widget.scalability/view.scss: no such file or directory */`],
})
export class PortalAnalysisWidgetScalabilityComponent implements OnInit, OnChanges {
    @Input() data: ResearcherData;
    @Input() years: number[];
    @Input() periodStart?: number;
    @Input() periodEnd?: number;

    public researcher: any[];
    public products: any[];
    public avgData: Record<number, number> = {};

    chartBar: Chart | null = null;
    chartBar2: Chart | null = null;
    chartTopic: Chart | null = null;

    private researcherData: number[] = [];
    private avgDataArr: number[] = [];

    public overallTotal: number = 0;
    public researcherTotal: number = 0;

    public topicLabels: string[] = [];
    public topicData: number[] = [];
    public topKeyword: { name: string; count: number } | null = null;
    public bottomKeyword: { name: string; count: number } | null = null;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['periodStart'] || changes['periodEnd']) {
            this.loadData();
            this.loadTopicData();
        }
    }

    constructor(@Inject( Service) private service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.mapping();
        this.loadData();
        this.loadTopicData();
        await this.service.render();
    }

    public mapping() {
        this.researcher = this.data.researcher;
        this.periodEnd = this.data.periodEnd;
        this.periodStart = this.data.periodStart;
        this.products = this.data.products;
        this.avgData = this.data.avgData;
        this.service.render();
    }

    private loadData() {
        if (!this.years || this.years.length === 0) return;

        const yearCounts: Record<number, number> = {};
        for (const p of this.products) {
            const year = Number(p.pub_year);
            if (!year || !this.years.includes(year)) continue;
            yearCounts[year] = (yearCounts[year] || 0) + 1;
        }
        this.researcherData = this.years.map(y => yearCounts[y] ?? 0);

        // 평균 데이터 매핑
        this.avgDataArr = this.years.map(y => this.avgData[y] ?? 0);

        // 합계 계산 (연도 범위 고려)
        this.overallTotal = this.years.reduce((sum, y) => sum + (this.avgData[y] ?? 0), 0);
        this.researcherTotal = this.researcherData.reduce((sum, v) => sum + v, 0);

        this.renderBarChart();
        this.renderBarChart2();
    }

    private loadTopicData() {
        if (!this.products) return;

        const filtered = this.products.filter(p => {
            const year = Number(p.pub_year);
            return year >= this.periodStart && year <= this.periodEnd;
        });

        const freq: Record<string, number> = {};

        for (const p of filtered) {
            let raw = p.kr_keywords?.trim() || p.en_keywords?.trim();
            if (!raw) continue;

            const parts = raw.split(";")
                .map(x => x.trim())
                .filter(x => x.length > 0);

            for (const kw of parts) {
                const norm = kw; // 정규화 안 하고 원본 그대로 씀
                freq[norm] = (freq[norm] || 0) + 1;
            }
        }

        const sorted = Object.entries(freq).sort((a, b) => b[1] - a[1]);

        this.topicLabels = sorted.map(([kw]) => kw);
        this.topicData = sorted.map(([_, cnt]) => cnt);

        if (sorted.length > 0) {
            this.topKeyword = { name: sorted[0][0], count: sorted[0][1] };
            this.bottomKeyword = { name: sorted[sorted.length - 1][0], count: sorted[sorted.length - 1][1] };
        } else {
            this.topKeyword = null;
            this.bottomKeyword = null;
        }

        this.renderTopicChart();
    }

    // private normalizeKeyword(kw: string): string {
    //     // 1) 모든 공백 제거
    //     let normalized = kw.replace(/\s+/g, "");
    //     // 2) 대소문자 통일
    //     normalized = normalized.toLowerCase();
    //     // 3) 필요하면 특수문자 처리 (예: 괄호 등)
    //     normalized = normalized.replace(/[()]/g, "");
    //     return normalized;
    // }

    formatValue(value: number): string {
        return value.toString().padStart(3, '0');
    }

    formatAvg(value: number): string {
        return value.toFixed(1);
    }

    private renderBarChart(): void {
        if (this.chartBar) this.chartBar.destroy();
        this.chartBar = new Chart('barChart', {
            type: 'bar',
            data: {
                labels: this.years,
                datasets: [
                    {
                        label: '연구자',
                        data: this.researcherData,
                        backgroundColor: '#5381F2',
                        borderWidth: 0,
                        borderRadius: 5,
                        categoryPercentage: 0.7,
                        barPercentage: 0.8,
                    },
                    {
                        label: '평균',
                        data: this.avgDataArr,
                        backgroundColor: '#4FD1B8',
                        borderWidth: 0,
                        borderRadius: 5,
                        categoryPercentage: 0.7,
                        barPercentage: 0.8,
                    },
                ],
            },
            options: {
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                },
                scales: {
                    x: {
                        display: false,
                        grid: { display: false },
                    },
                    y: {
                        ticks: {
                            autoSkip: false, // 스크롤 기반이므로 모든 년도 표시
                            font: {
                                size: 20,
                                weight: 'bold',
                            },
                            color: '#000',
                        },
                        grid: { display: false },
                        border: {
                            display: true,
                            width: 2,
                            color: '#DFE1E5'
                        },
                    },
                },
            },
        } as ChartConfiguration);
    }

    private renderBarChart2(): void {
        if (this.chartBar2) this.chartBar2.destroy();

        this.chartBar2 = new Chart('barChart2', {
            type: 'bar',
            data: {
                labels: [this.researcher?.name ?? "연구자", "전체 연구자"],
                datasets: [
                    {
                        label: '건수',
                        data: [this.researcherTotal, this.overallTotal],
                        backgroundColor: ['#5381F2', '#4FD1B8'],
                        borderRadius: 6,
                        borderWidth: 0,
                        categoryPercentage: 0.9,
                        barPercentage: 0.7,
                    },
                ],
            },
            options: {
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                },
                scales: {
                    x: {
                        display: false,
                        grid: { display: false, drawBorder: true, borderWidth: 2, borderColor: '#DFE1E5' },
                    },
                    y: {
                        ticks: {
                            font: { size: 14, weight: '500' },
                            color: '#8B93A0',
                        },
                        grid: { display: false, drawBorder: false },
                        border: {
                            display: true,
                            width: 2,
                            color: '#DFE1E5'
                        },
                    },
                },
            },
        } as ChartConfiguration);
    }

    private renderTopicChart(): void {
        if (this.chartTopic) this.chartTopic.destroy();

        const colors = this.topicLabels.map((_, i) => {
            const hue = Math.floor(Math.random() * 360); // 0 ~ 360 색상
            const saturation = 60 + Math.random() * 20;  // 60% ~ 80% 채도
            const lightness = 50 + Math.random() * 10;   // 50% ~ 60% 명도
            return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
        });

        this.chartTopic = new Chart('topicChart', {
            type: 'doughnut',
            data: {
                labels: this.topicLabels,
                datasets: [
                    {
                        data: this.topicData,
                        // backgroundColor: [
                        //     '#5381F2',
                        //     '#4FD1B8',
                        //     '#FFBCF9',
                        //     '#B3D4FF',
                        //     '#1A2C76',
                        //     '#B5A9FF',
                        // ],
                        backgroundColor: colors,
                        borderWidth: 0,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                cutout: '45%',
                layout: {
                    padding: {
                        top: 15,
                    },
                },
                plugins: {
                    legend: {
                        display: false
                    },
                },
                // plugins: {
                //     legend: {
                //         position: 'bottom',
                //         labels: {
                //             usePointStyle: true,
                //             pointStyle: 'circle',
                //             boxWidth: 7,
                //             boxHeight: 7,
                //             color: '#707988',
                //             font: {
                //                 size: 14,
                //             },
                //             padding: 10,
                //         },
                //     },
                //     tooltip: {
                //         enabled: true,
                //     },
                // },
            },
        } as ChartConfiguration);
    }
}

export default PortalAnalysisWidgetScalabilityComponent;